<template>
  <div class="gorgias-modal-footer">
    <div class="gorgias-modal-footer__section gorgias-modal-footer__chat">
      <icon-chat />
      <span
        class="gorgias-modal-footer__label text-other-button-link-uppercase"
        @click="handleChatClick"
        v-text="$string('product.contact_form.footer.chat')"
      />
    </div>
    <div class="gorgias-modal-footer__section">
      <icon-phone />
      <span
        class="gorgias-modal-footer__label text-other-button-link-uppercase"
        v-text="$string('product.contact_form.footer.call')"
      />
      <span
        class="gorgias-modal-footer__text text-body-s-regular"
        v-html="$string('product.contact_form.footer.phone_number')"
      />
    </div>
    <div class="gorgias-modal-footer__section">
      <icon-email />
      <span
        class="gorgias-modal-footer__label text-other-button-link-uppercase"
        v-text="$string('product.contact_form.footer.email')"
      />
      <span
        class="gorgias-modal-footer__text text-body-s-regular"
        v-html="$string('product.contact_form.footer.email_address')"
      />
    </div>
    <div class="gorgias-modal-footer__section gorgias-modal-footer__appointment">
      <icon-calendar />
      <span
        class="gorgias-modal-footer__label text-other-button-link-uppercase"
      >
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://outlook.office365.com/owa/calendar/JohnHardySohoBoutique@johnhardyint.onmicrosoft.com/bookings/"
        >
          {{ $string('product.contact_form.footer.book_appointment') }}
        </a>
      </span>
    </div>
    <div class="gorgias-modal-footer__section">
      <div
        class="gorgias-modal-footer__hours text-body-s-medium"
        v-html="$string('product.contact_form.footer.hours_operation')"
      />

      <div
        class="gorgias-modal-footer__hours text-body-s-regular"
        v-text="$string('product.contact_form.footer.hours_1')"
      />
      <div
        class="gorgias-modal-footer__hours text-body-s-regular"
        v-text="$string('product.contact_form.footer.hours_2')"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: Gorgias modal footer (gorgias-modal-footer)
 * -----------------------------------------------------------------------------
 * Footer for Gorgias Modal Contact Form.
 *
 */

import { mapActions } from 'vuex'

import IconEmail from '~icons/general/email.svg'
import IconPhone from '~icons/general/phone.svg'
import IconChat from '~icons/general/chat.svg'
import IconCalendar from '~icons/general/calendar.svg'

export default {
  name: 'GorgiasModalFooter',

  components: {
    IconEmail,
    IconPhone,
    IconChat,
    IconCalendar,
  },

  props: {
    uid: {
      type: String,
      required: true,
    },
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      toggleOverlay: 'overlays/toggle',
    }),

    closeOverLay() {
      this.toggleOverlay({
        namespace: `gorgiasModal-${this.uid}`,
        ignoreDismissed: true,
        component: 'gorgias-modal-form',
      })
    },

    handleChatClick() {
      this.closeOverLay()
      window.GorgiasChat.open()
    },
  },
}
</script>

<style lang="scss">
@import './gorgias-modal-footer';
</style>
